var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { useUncontrolledProp } from 'uncontrollable';
import { QuestionSVG } from '@snack-uikit/icons';
import { extractSupportProps } from '@snack-uikit/utils';
import { Tooltip } from '../Tooltip';
import { SIZE, SIZES_MAP, TRIGGER, TRIGGER_MAP } from './constants';
import styles from './styles.module.css';
export function QuestionTooltip(_a) {
    var { size = SIZE.Xs, trigger = TRIGGER.Hover, tooltipClassname, className, open, onOpenChange, tabIndex = 0, triggerSupportProps = {} } = _a, rest = __rest(_a, ["size", "trigger", "tooltipClassname", "className", "open", "onOpenChange", "tabIndex", "triggerSupportProps"]);
    const [isOpen, setIsOpen] = useUncontrolledProp(open, false, onOpenChange);
    return (_jsx(Tooltip, Object.assign({}, rest, { className: tooltipClassname, open: isOpen, onOpenChange: setIsOpen, trigger: TRIGGER_MAP[trigger], children: ({ getReferenceProps, ref }) => (_jsx("span", Object.assign({}, getReferenceProps(), extractSupportProps(triggerSupportProps), { ref: ref, "data-size": size, "data-opened": isOpen, "data-trigger": trigger, className: cn(styles.questionTooltip, className), role: 'button', tabIndex: tabIndex, children: _jsx(QuestionSVG, { size: SIZES_MAP[size] }) }))) })));
}
